// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimFileOutputModel {
    static getAttributeTypeMap() {
        return ClaimFileOutputModel.attributeTypeMap;
    }
}
ClaimFileOutputModel.discriminator = undefined;
ClaimFileOutputModel.attributeTypeMap = [
    {
        "name": "fileIdentifier",
        "baseName": "fileIdentifier",
        "type": "string"
    },
    {
        "name": "fileName",
        "baseName": "fileName",
        "type": "string"
    }
];
//# sourceMappingURL=claimFileOutputModel.js.map